var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34416 13.656C1.58008 12.918 0.970622 12.0353 0.55135 11.0592C0.132078 10.0832 -0.0886119 9.03345 -0.0978425 7.97121C-0.107073 6.90898 0.0953406 5.85554 0.497588 4.87237C0.899835 3.8892 1.49386 2.99598 2.245 2.24484C2.99614 1.4937 3.88936 0.899675 4.87253 0.497427C5.8557 0.0951804 6.90914 -0.107233 7.97137 -0.0980027C9.03361 -0.0887722 10.0834 0.131918 11.0594 0.55119C12.0354 0.970462 12.9182 1.57992 13.6562 2.344C15.1134 3.85282 15.9198 5.87364 15.9016 7.97121C15.8833 10.0688 15.042 12.0753 13.5587 13.5585C12.0754 15.0418 10.0689 15.8832 7.97137 15.9014C5.8738 15.9196 3.85298 15.1133 2.34416 13.656ZM3.47216 12.528C4.67306 13.7289 6.30183 14.4036 8.00016 14.4036C9.69849 14.4036 11.3273 13.7289 12.5282 12.528C13.7291 11.3271 14.4037 9.69833 14.4037 8C14.4037 6.30167 13.7291 4.6729 12.5282 3.472C11.3273 2.2711 9.69849 1.59644 8.00016 1.59644C6.30183 1.59644 4.67306 2.2711 3.47216 3.472C2.27126 4.6729 1.5966 6.30167 1.5966 8C1.5966 9.69833 2.27126 11.3271 3.47216 12.528ZM11.3922 5.736L9.12816 8L11.3922 10.264L10.2642 11.392L8.00016 9.128L5.73616 11.392L4.60816 10.264L6.87216 8L4.60816 5.736L5.73616 4.608L8.00016 6.872L10.2642 4.608L11.3922 5.736Z",
    fill: "#034A73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossBlue);
export default __webpack_public_path__ + "static/media/cross_blue.d159249a958c6ea3320357e6b4b8dc5a.svg";
export { ForwardRef as ReactComponent };